<template>
  <contact-form-fieldset
    class="contact-form__request-type"
    class-content-wrapper="contact-form__radio-buttons-horizontal"
    :legend="texts.caseTypeLabel"
    :required="true"
  >
    <div
      v-for="(title, type) in requestTypes"
      :key="type"
      :class="{
        'contact-form-radio-button--active': requestTypeModel === type,
      }"
      class="radio-button contact-form-radio-button"
      @click="requestTypeModel = type"
    >
      <input
        :id="type"
        v-model="requestTypeModel"
        :value="type"
        type="radio"
        name="requestType"
        class="contact-form-radio-button__input"
      />
      <label :for="type" class="marker contact-form-radio-button__label">{{
        title
      }}</label>
    </div>
  </contact-form-fieldset>
</template>

<script>
import ContactFormFieldset from './ContactFormFieldset.vue';

export default {
  name: 'RequestType',

  components: {
    ContactFormFieldset,
  },

  props: {
    requestTypes: {
      type: Object,
      required: true,
    },
    requestType: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      texts: theme_vars.contactTexts,
    };
  },

  computed: {
    requestTypeModel: {
      get() {
        return this.requestType;
      },
      set(value) {
        this.$emit('update:requestType', value);
      },
    },
  },
};
</script>
